import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubtract = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 13H5a1 1 0 010-2h14a1 1 0 010 2z",
			fillRule: "nonzero"
		})
	})
});
export { SvgSubtract as ReactComponent };
